export const ADD_ORG = 'SET_ORG';
export const CLEAR_ORG = 'CLEAR_ORG';
